/**
 * Collection page functionality
 */

(function() {
  'use strict';

  class CollectionPage {
    constructor() {
      this.sortSelect = document.querySelector('[data-sort-select]');
      this.filterForm = document.querySelector('.collection-filters');
      this.productGrid = document.querySelector('[data-product-grid]');
      this.loadMoreBtn = document.querySelector('[data-load-more-button]');
      this.loadMoreContainer = document.querySelector('[data-load-more-container]');
      this.toolbarCount = document.querySelector('.collection-toolbar__count-number');

      this.bindEvents();
    }

    bindEvents() {
      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', () => this.handleSort());
      }

      if (this.filterForm) {
        this.filterForm.addEventListener('change', () => this.handleFilter());
      }

      if (this.loadMoreBtn) {
        this.loadMoreBtn.addEventListener('click', () => this.loadMore());
      }

      const filterToggle = document.querySelector('.filter-toggle');
      const filterPanel = document.querySelector('.filter-panel');
      if (filterToggle && filterPanel) {
        filterToggle.addEventListener('click', () => {
          filterPanel.classList.toggle('filter-panel--open');
        });
      }
    }

    async handleSort() {
      const sortValue = this.sortSelect.value;
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sortValue);

      /* Update URL without reload */
      window.history.pushState({}, '', url.toString());

      /* Show loading state */
      if (this.productGrid) {
        this.productGrid.style.opacity = '0.4';
        this.productGrid.style.pointerEvents = 'none';
        this.productGrid.style.transition = 'opacity 0.2s ease';
      }
      this.sortSelect.disabled = true;

      try {
        const response = await fetch(url.toString());
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        /* Replace product grid */
        const newGrid = doc.querySelector('[data-product-grid]');
        if (newGrid && this.productGrid) {
          this.productGrid.innerHTML = newGrid.innerHTML;
        }

        /* Replace load more section */
        const newLoadMore = doc.querySelector('[data-load-more-container]');
        if (this.loadMoreContainer && newLoadMore) {
          this.loadMoreContainer.innerHTML = newLoadMore.innerHTML;
          /* Re-bind load more button */
          this.loadMoreBtn = this.loadMoreContainer.querySelector('[data-load-more-button]');
          if (this.loadMoreBtn) {
            this.loadMoreBtn.addEventListener('click', () => this.loadMore());
          }
        } else if (this.loadMoreContainer) {
          this.loadMoreContainer.innerHTML = '';
        }

        /* Update product count */
        const newCount = doc.querySelector('.collection-toolbar__count-number');
        if (this.toolbarCount && newCount) {
          this.toolbarCount.textContent = newCount.textContent;
        }

      } catch (error) {
        /* Fallback: do a full page reload */
        console.error('Sort fetch failed, reloading:', error);
        window.location = url;
        return;
      } finally {
        if (this.productGrid) {
          this.productGrid.style.opacity = '1';
          this.productGrid.style.pointerEvents = '';
        }
        this.sortSelect.disabled = false;
      }
    }

    handleFilter() {
      const formData = new FormData(this.filterForm);
      const url = new URL(window.location);
      url.search = '';

      formData.forEach((value, key) => {
        if (value) {
          url.searchParams.append(key, value);
        }
      });

      window.location = url;
    }

    async loadMore() {
      if (!this.loadMoreBtn) return;
      const nextUrl = this.loadMoreBtn.dataset.nextUrl;
      const totalProducts = parseInt(this.loadMoreBtn.dataset.totalProducts);

      if (!nextUrl) return;

      this.loadMoreBtn.classList.add('is-loading');
      this.loadMoreBtn.disabled = true;

      try {
        const response = await fetch(nextUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newProducts = doc.querySelectorAll('[data-product-item]');
        newProducts.forEach(product => {
          this.productGrid.appendChild(product);
        });

        const currentShown = this.productGrid.querySelectorAll('[data-product-item]').length;
        const productsShownEl = document.querySelector('[data-products-shown]');
        if (productsShownEl) {
          productsShownEl.textContent = currentShown;
        }

        const progressBar = document.querySelector('[data-progress-bar]');
        if (progressBar && totalProducts) {
          progressBar.style.width = ((currentShown / totalProducts) * 100) + '%';
        }

        const newLoadMoreButton = doc.querySelector('[data-load-more-button]');
        if (newLoadMoreButton && newLoadMoreButton.dataset.nextUrl) {
          this.loadMoreBtn.dataset.nextUrl = newLoadMoreButton.dataset.nextUrl;
        } else {
          this.loadMoreBtn.style.display = 'none';
        }

      } catch (error) {
        console.error('Failed to load more products:', error);
      } finally {
        if (this.loadMoreBtn) {
          this.loadMoreBtn.classList.remove('is-loading');
          this.loadMoreBtn.disabled = false;
        }
      }
    }
  }

  /* Handle browser back/forward with sort */
  window.addEventListener('popstate', function() {
    window.location.reload();
  });

  document.addEventListener('DOMContentLoaded', () => {
    new CollectionPage();
  });

})();
